namespace Portico.Models.Enterprise {

    export interface IVoiceMailOptIn {
        isVmOptedIn: boolean;
        phoneNumberId: number;
    }

    export class VoiceMailOptIn implements IVoiceMailOptIn {
        isVmOptedIn: boolean;
        phoneNumberId: number;

        constructor(obj?: IVoiceMailOptIn) {
            this.isVmOptedIn = false;
            this.phoneNumberId = null;

			if (obj) {
				this.isVmOptedIn = obj.isVmOptedIn || false;
                this.phoneNumberId = obj.phoneNumberId || null;
            }
        }
    }
}
